import React from "react";
import { useState } from "react";
import { priceFormatter } from "./algoritem";

function GiftCards() {
  const [edit, setEdit] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [giftCards, setGiftCards] = useState([
    { name: "אביעד וטל", surName: "שילה", amount: 200, phone: 585662837 },
    { name: "אהרון ושירה", surName: "רוזן", amount: 500, phone: 532758906 },
  ]);

  const onChangeInput = ({ target: { value } }) => {
    setInputValue(value);
  };
  const onClickEdit = (index, phone) => {
    setEdit((prev) => !prev);
    console.log(index);
    // when the object.phone == phone change object.amount to value
    const newGiftCards = [...giftCards];
    newGiftCards[index].amount=newGiftCards[index].amount-inputValue;
    setGiftCards(newGiftCards)
    setInputValue("")
    // setGiftCards(giftCards[index].amount=inputValue)
    //    const newArrProducts = [...choosenProducts];
   // newArrProducts[index].productAmount =
  //   newArrProducts[index].productAmount + 1;
  // setChoosenProducts(newArrProducts);
   };
  console.log(inputValue);
  return (
    <div className="list-con">
      {giftCards.map(({ name, phone, surName, amount }, index) => (
        <div className="list-product-con" key={phone}>
          <h2>{name}</h2>
          <h3>{surName}</h3>
          <h4>0{phone}</h4>
          <h4>
            {priceFormatter.format(amount)}{" "}
            {edit && (
              <input
                value={inputValue}
                onChange={onChangeInput}
                type="number"
              />
            )}
          </h4>
          <button
            className="edit-product"
            onClick={() => onClickEdit(index, phone)}
          >
            Edit{" "}
          </button>
        </div>
      ))}
    </div>
  );
}

export default GiftCards;
